import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/helpers/api-helper";
import ExternalApi from "@infrastructure/external-api";
export const ExternalRegistertionAsync = createAsyncThunk("external/register", async (registration, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ExternalApi.RegisterExternal(registration);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const GetByPersonAsync = createAsyncThunk("external/getByCompanyId", async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ExternalApi.GetByPerson(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const GetExternalByUserIdAsync = createAsyncThunk("external/getByUserId", async (Id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ExternalApi.GetExternalByUserId(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const DeleteExternalByIdAsync = createAsyncThunk("external/deleteExternalById", async (Id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ExternalApi.DeleteExternalById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const GetExternalCountPerCompanyAsync = createAsyncThunk("external/getExternalCountPerCompany", async (personId, { rejectWithValue }) => {
    try {
        const response = await ExternalApi.GetExternalCountPerCompany(personId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
